export default "__VITE_ASSET__DJ97g0O8__"